import { CornerRadiusModel } from './corner-radius.model';
import { TextStyleModel } from './text-style.model';

export class ImageStyleModel extends TextStyleModel {
    imageAlignment: string;
    doBorder: boolean;
    borderWidth: number;
    borderColor: string;
    cornerRadius: CornerRadiusModel;

    constructor(apiModel?: any) {
        super(apiModel);
        if (apiModel) {
            this.setFromApiModel(apiModel);
        }

        if (!this.cornerRadius) {
            this.cornerRadius = new CornerRadiusModel();
        }
    }

    clone(): ImageStyleModel {
        const clone = new ImageStyleModel(this._toBlockStyleModel());

        if (this.template) {
            clone.template = this.template;
        }
        // todo: create new or use existing chart styles model for briefing rhp
        if (this.accentColor) {
            clone.accentColor = this.accentColor;
        }

        return clone;
    }

    equals(other: ImageStyleModel): boolean {
        if (!super.equals(other, false)) {
            return false;
        }

        if (this.imageAlignment !== other.imageAlignment) {
            return false;
        }

        if (this.doBorder !== other.doBorder) {
            return false;
        }

        if (this.borderWidth !== other.borderWidth) {
            return false;
        }

        if (this.borderColor !== other.borderColor) {
            return false;
        }

        if (this.cornerRadius && this.cornerRadius.hasOwnProperty('equals') && !this.cornerRadius.equals(other.cornerRadius)){
            return false;
        }

        return true;
    }

    setFromApiModel(apiModel: any): void {
        super.setFromApiModel(apiModel);

        if (typeof apiModel === 'string') {
            apiModel = JSON.parse(apiModel);
        }

        if (apiModel.hasOwnProperty('imageAlignment')) {
            this.imageAlignment = apiModel.imageAlignment;
        }

        if (apiModel.hasOwnProperty('doBorder')) {
            this.doBorder = apiModel.doBorder;
        }

        if (apiModel.hasOwnProperty('borderWidth')) {
            this.borderWidth = apiModel.borderWidth;
        }

        if (apiModel.hasOwnProperty('borderColor')) {
            this.borderColor = apiModel.borderColor;
        }
        if (apiModel.hasOwnProperty('cornerRadius')) {
            this.cornerRadius = new CornerRadiusModel(
                apiModel.cornerRadius.cornerRadiusAll, apiModel.cornerRadius.cornerRadiusOption, apiModel.cornerRadius.topLeftCornerRadius,
                apiModel.cornerRadius.topRightCornerRadius, apiModel.cornerRadius.bottomLeftCornerRadius, apiModel.cornerRadius.bottomRightCornerRadius
            );
        }
    }

    toApi(): any {
        const apiModel = super.toApi();
        apiModel.imageAlignment = this.imageAlignment;
        apiModel.doBorder = this.doBorder;
        apiModel.borderWidth = this.borderWidth;
        apiModel.borderColor = this.borderColor;
        apiModel.cornerRadius = this.cornerRadius;

        return apiModel;
    }

    protected _toBlockStyleModel(): any {
        return {
            color: this.color,
            fontFamily: this.fontFamily,
            fontSize: this.fontSize,
            bold: this.bold,
            italics: this.italics,
            underlined: this.underlined,
            alignment: this.alignment,
            styleState: this.styleState,
            displayStyleState: this.displayStyleState,
            imageAlignment: this.imageAlignment,
            backgroundColor: this.backgroundColor,
            padding: this.padding,
            doBorder: this.doBorder,
            borderWidth: this.borderWidth,
            borderColor: this.borderColor,
            cornerRadius: this.cornerRadius
        };
    }

    toBlockStyle(): any {
        if (!this.isSavedStyle()) {
            return this._toBlockStyleModel();
        } else {
            return {
                styleState: this.styleState
            };
        }
    }
}
